const yesterday = new Date();
yesterday.setDate(yesterday.getDate() - 1);
const today = new Date();
export const isInvalidDate = (date: Date) => isNaN(date.getTime()) || date > yesterday;

export const isValidDate = (date : Date | '') => date === '' || (!isNaN(date.getTime()) && date < today);
export const isEmptyDate = (date : Date | '') => date === '';
export const isValidDY = (achDraftDay : number | '') => achDraftDay === '' || (achDraftDay > 0 && achDraftDay < 32 && achDraftDay);
